var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasUrl()
    ? _c("span", [
        _c("a", { attrs: { href: _vm.currentUrl, target: "_blank" } }, [
          _vm.getIcon() == "fa-instagram"
            ? _c("span", [
                _c("img", {
                  attrs: {
                    src: "/images/rebrush22/icons/icon-instagram-black.svg"
                  }
                })
              ])
            : _vm.getIcon() == "fa-facebook-square"
            ? _c("span", [
                _c("img", {
                  attrs: {
                    src: "/images/rebrush22/icons/icon-facebook-black.svg"
                  }
                })
              ])
            : _c("span", [_c("i", { class: ["fa", _vm.getIcon(), "fa-2x"] })])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a88e7252", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a88e7252","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfilePlatform.vue
// module id = 521
// module chunks = 2